import { DefaultTheme } from 'styled-components';

import {
  CountItemTitle,
  CountItemValue,
  CountItemWrapper,
  CountValueWrapper,
  StateColorSquare
} from './CountItem.styles';

type Props = {
  title: string;
  value: number;
  color: keyof DefaultTheme['colors'];
};

export const CountItem: React.FC<Props> = ({ value, title, color }) => {
  return (
    <CountItemWrapper>
      <StateColorSquare color={color} />
      <CountValueWrapper>
        <CountItemTitle>{title}</CountItemTitle>
        <CountItemValue>{value}</CountItemValue>
      </CountValueWrapper>
    </CountItemWrapper>
  );
};
